<template>
  <div class="enterprise-list-page enterprise-list-page--report">
    <!-- Header Card -->
        <PageHeader icon="fas fa-prescription-bottle-alt">
      <template #title>
        Laporan Pendapatan Apotek
      </template>
      <template #subtitle>
        Analisis pendapatan penjualan obat dan layanan apotek secara berkala
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <b-tabs class="report-enterprise-tabs" content-class="mt-3">
              <b-tab title="Pendapatan Apotik" active>
                <div class="mt-6"></div>
                <PharmacyReportTable
                  @modalShow="modalShow"
                  @dataModal="dataModalShow"
                />
              </b-tab>
              <b-tab title="Pendapatan Obat Klinik">
                <div class="mt-6"></div>
                <MedicineTable
                  @modalShow="modalShow"
                  @dataModal="dataModalShow"
                />
              </b-tab>
            </b-tabs>
            <ModalReport
              :reportType="reportType"
              :reportName="reportName"
              :dataModal="dataModal"
              :excel="dataExcel"
            />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>

import Card from '@/view/content/Card.vue'
import ReportPageShell from '@/component/reports/ReportPageShell.vue'
import Table from '@/component/reports/PayrollReport.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import MedicineTable from "@/component/reports/PaymentPharmacyReport.vue"
import EcommerceTable from "@/component/reports/EcommerceRecordReport.vue"
import PharmacyReportTable from "@/component/reports/PharmacyReport.vue"
import ModalReport from "@/component/general/ModalReport.vue"
export default {

  components: {
    Card,
    ReportPageShell,
    Table,
    MedicineTable,
    EcommerceTable,
    PharmacyReportTable,
    ModalReport,
   
  },
  data(){
    return{
      reportType:null,
      reportName:null,

      dataModal:[],
      dataExcel:[],
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name

    }
  },
  methods:{
    modalShow(type,name){
      this.reportType = type
      this.reportName = name
      
      this.$bvModal.show('modal-report')
      // this.dataModal()
    },
    dataModalShow(dataModal,excel){
      this.dataModal = dataModal
      this.dataExcel = excel

    }
  },
  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Laporan", route: "" },
      { title: "Laporan Pendapatan Apotik" },
    ])
  },

}
</script>

<style>
</style>
